import { CustodianStatementLink } from "@/shared/types";

export const footerTemplate = "AllegacyFooter";

export const investmentRiskDisclaimer = "Not NCUA Approved: The investment is not a deposit or obligation of, or guaranteed or endorsed by, any financial institution and is not insured by the Nation Credit Union Administration, the Federal Reserve Board, or any other U.S. governmental agency.";

export const displayMyProfileEditMode = false;

export const logoutRedirectUrl = null;

export const faqTemplate = "AllegacyForms";

export const faqInstructionsTemplate = "";

export const displayAdvice = true;

export const displayFaqExternalLinks = true;

export const displayFaqInstructions = true;

export const displayInvestmentsSection = true;

export const disabledRouteRedirectTarget = null;

export const displaySettingsLinkedAccounts = true;

export const allowEmailEdit = false;

export const profileEditInformationHtml = "Please login to your Allegacy online account to make updates to locked information.";

export const priorYearContributionOption = true;

export const allowReimbursement = true;

export const showPendingReimbursements = true;

export const showAlternateOnboardingCompleteMessage = false;

const disabledRoutesDictionary = {};

export const disabledRoutes = disabledRoutesDictionary;

export const termsUrl = "/allegacy_terms.pdf";

export const feeTemplate = "/Allegacy_Fee_Schedule_08012023.pdf";

export const isFeeTemplateExternalUrl = true;

export const quarterlyPaperStatementFee = 2.25;

export const manageHsaCardsInPortal = false;

export const displayPriorYearContributionDisclaimerCopy = false;

export const investmentCustodian = "drivewealth";

export const displayProjectedContributions = true;

export const allowUserToEditContributions = true;

export const displayPdfForESign = true;

export const eSignPdfUrl = "/Allegacy_eSign_Disclosure_and_Consent.pdf";

export const displayFooterLegalSection = true;

export const contactDetailsSetAtBank = true;

export const allowFamilyMemberSsnInput = true;

export const showHsaStoreShopTab = true;

export const displayHealthcareClaims = true;
